var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-invalid-feedback',{attrs:{"force-show":_vm.hasErrors}},[_vm._v("\n"+_vm._s(_vm.$t('forms.correct_form_errors'))+":\n  "),_c('ul',_vm._l((_vm.activeErrorMessages),function(error,index){return _c('li',{key:index},[_vm._v(_vm._s(error))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }